import { render, staticRenderFns } from "./CollectionPaginator.vue?vue&type=template&id=3ddd17fc&"
import script from "./CollectionPaginator.vue?vue&type=script&lang=js&"
export * from "./CollectionPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports